import React from 'react';
import { Button, useListContext } from 'react-admin';

const ExportFilteredButton = () => {
    const { filterValues } = useListContext();

    const handleExport = () => {
        const params = new URLSearchParams();

        Object.entries(filterValues || {}).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params.append(key, String(value));
            }
        });

        const url =
            `//sboportal.org.in/admin/api/v1/widthdraw/export?${params.toString()}`;

        window.open(url, '_blank');
    };

    return <Button label="Export" onClick={handleExport} />;
};

export default ExportFilteredButton;